var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4036_565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.1664 9.73682L1.91641 1.48639C1.74195 1.41162 1.55805 1.33643 1.37586 1.33643C1.00534 1.33643 0.641095 1.48677 0.374689 1.76826C-0.0214103 2.22631 -0.112706 2.84893 0.145106 3.36498L4.125 11.0001L0.145235 18.6356C-0.112577 19.1521 -0.0212685 19.7743 0.37486 20.1941C0.640751 20.4754 1.00478 20.626 1.37517 20.626C1.55779 20.626 1.74174 20.5897 1.91615 20.5145L21.1664 12.2634C21.6726 12.0472 22.0004 11.5497 22.0004 10.9997C21.9613 10.4501 21.6734 9.95166 21.1664 9.73682ZM1.37414 2.75139C1.37328 2.75182 1.37457 2.75053 1.37414 2.75139L19.0223 10.3126H5.31524L1.37414 2.75139ZM1.36426 19.2716L5.31524 11.6876H18.9836L1.36426 19.2716Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4036_565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.6e4ab3fe6f7db2510db38f211d9885b4.svg";
export { ForwardRef as ReactComponent };